// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { GetAppByQreIdImportDatabasesData, GetAppByQreIdImportDatabasesResponses, GetAppByQreIdSurveyData, GetAppByQreIdSurveyErrors, GetAppByQreIdSurveyResponses, GetConfigData, GetConfigResponses, GetDebugByOperationIdOperationStatusDebugData, GetDebugByOperationIdOperationStatusDebugErrors, GetDebugByOperationIdOperationStatusDebugResponses, GetDebugSurveyByQreIdCatiexProjectLinkData, GetDebugSurveyByQreIdCatiexProjectLinkErrors, GetDebugSurveyByQreIdCatiexProjectLinkResponses, GetMetricsData, GetMetricsResponses, GetSampleByOperationIdOperationStatusData, GetSampleByOperationIdOperationStatusErrors, GetSampleByOperationIdOperationStatusResponses, GetSampleByQreIdMaxIpsosIdData, GetSampleByQreIdMaxIpsosIdErrors, GetSampleByQreIdMaxIpsosIdResponses, GetSampleByQreIdOperationsData, GetSampleByQreIdOperationsErrors, GetSampleByQreIdOperationsResponses, GetSampleByQreIdSampleAutocompleteData, GetSampleByQreIdSampleAutocompleteErrors, GetSampleByQreIdSampleAutocompleteResponses, GetSampleRowsByQreIdSampleColumnsData, GetSampleRowsByQreIdSampleColumnsErrors, GetSampleRowsByQreIdSampleColumnsResponses, GetSampleRowsByQreIdSurveyDataData, GetSampleRowsByQreIdSurveyDataErrors, GetSampleRowsByQreIdSurveyDataResponses, GetSurveyByQreIdCatiexProjectLinkData, GetSurveyByQreIdCatiexProjectLinkErrors, GetSurveyByQreIdCatiexProjectLinkResponses, GetSurveyByQreIdQuotaFlatStructureData, GetSurveyByQreIdQuotaFlatStructureErrors, GetSurveyByQreIdQuotaFlatStructureResponses, GetSurveyByQreIdResponseCodesData, GetSurveyByQreIdResponseCodesErrors, GetSurveyByQreIdResponseCodesResponses, LoginWithTokenData, LoginWithTokenResponses, PostByQreIdCatiExAliasSetData, PostByQreIdCatiExAliasSetErrors, PostByQreIdCatiExAliasSetResponses, PostByQreIdFinalizeSurveyData, PostByQreIdFinalizeSurveyErrors, PostByQreIdFinalizeSurveyResponses, PostByQreIdPreCallInfoSetData, PostByQreIdPreCallInfoSetErrors, PostByQreIdPreCallInfoSetResponses, PostByQreIdQuotaTargetSetData, PostByQreIdQuotaTargetSetErrors, PostByQreIdQuotaTargetSetResponses, PostByQreIdResponseCodesSetData, PostByQreIdResponseCodesSetErrors, PostByQreIdResponseCodesSetResponses, PostCommandByQreIdFileExportSampleData, PostCommandByQreIdFileExportSampleErrors, PostCommandByQreIdFileExportSampleResponses, PostCommandChangeSampleResponseCodeData, PostCommandChangeSampleResponseCodeErrors, PostCommandChangeSampleResponseCodeResponses, PostCommandCreateSampleData, PostCommandCreateSampleErrors, PostCommandCreateSampleResponses, PostCommandDeleteSampleByDuplicityData, PostCommandDeleteSampleByDuplicityErrors, PostCommandDeleteSampleByDuplicityResponses, PostCommandDeleteSampleData, PostCommandDeleteSampleErrors, PostCommandDeleteSampleResponses, PostCommandFileImportSampleData, PostCommandFileImportSampleErrors, PostCommandFileImportSampleResponses, PostCommandFileUpdateSampleData, PostCommandFileUpdateSampleErrors, PostCommandFileUpdateSampleResponses, PostCommandResetSampleData, PostCommandResetSampleErrors, PostCommandResetSampleResponses, PostCommandUnblacklistSampleRowData, PostCommandUnblacklistSampleRowErrors, PostCommandUnblacklistSampleRowResponses, PostCommandUpdateSampleData, PostCommandUpdateSampleErrors, PostCommandUpdateSampleResponses, PostCommandUpdateSampleRowData, PostCommandUpdateSampleRowErrors, PostCommandUpdateSampleRowResponses, PostDebugByQreIdCatiExAliasSetData, PostDebugByQreIdCatiExAliasSetErrors, PostDebugByQreIdCatiExAliasSetResponses, PostDebugByQreIdFileExportSampleTestData, PostDebugByQreIdFileExportSampleTestErrors, PostDebugByQreIdFileExportSampleTestResponses, PostDebugByQreIdFinalizeSurveyData, PostDebugByQreIdFinalizeSurveyErrors, PostDebugByQreIdFinalizeSurveyResponses, PostDebugByQreIdPreCallInfoSetData, PostDebugByQreIdPreCallInfoSetErrors, PostDebugByQreIdPreCallInfoSetResponses, PostDebugByQreIdQuotaTargetSetData, PostDebugByQreIdQuotaTargetSetErrors, PostDebugByQreIdQuotaTargetSetResponses, PostDebugByQreIdResponseCodesSetData, PostDebugByQreIdResponseCodesSetErrors, PostDebugByQreIdResponseCodesSetResponses, PostDebugCatiexProjectCreatedData, PostDebugCatiexProjectCreatedErrors, PostDebugCatiexProjectCreatedResponses, PostDebugFileImportSampleTestData, PostDebugFileImportSampleTestErrors, PostDebugFileImportSampleTestResponses, PostDebugFileUpdateSampleTestData, PostDebugFileUpdateSampleTestErrors, PostDebugFileUpdateSampleTestResponses, PostExternalEventsCatiexProjectCreatedData, PostExternalEventsCatiexProjectCreatedErrors, PostExternalEventsCatiexProjectCreatedResponses, PostSampleByQreIdStatusData, PostSampleByQreIdStatusErrors, PostSampleByQreIdStatusResponses, PostSampleRowsByQreIdSampleRowDataData, PostSampleRowsByQreIdSampleRowDataErrors, PostSampleRowsByQreIdSampleRowDataResponses, PostSurveyByQreIdDefaultFiltersData, PostSurveyByQreIdDefaultFiltersErrors, PostSurveyByQreIdDefaultFiltersResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * update sample
 */
export const postCommandUpdateSample = <ThrowOnError extends boolean = false>(options?: Options<PostCommandUpdateSampleData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandUpdateSampleResponses, PostCommandUpdateSampleErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/update-sample',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * unblacklist sample rows - send remaining verified numbers to LBox
 */
export const postCommandUnblacklistSampleRow = <ThrowOnError extends boolean = false>(options?: Options<PostCommandUnblacklistSampleRowData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandUnblacklistSampleRowResponses, PostCommandUnblacklistSampleRowErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/unblacklist-sample-row',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get autocomplete suggestions for sample column
 */
export const getSampleByQreIdSampleAutocomplete = <ThrowOnError extends boolean = false>(options: Options<GetSampleByQreIdSampleAutocompleteData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSampleByQreIdSampleAutocompleteResponses, GetSampleByQreIdSampleAutocompleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample/{qreId}/sample-autocomplete',
        ...options
    });
};

/**
 * get app token from portal token
 * Returns app token from portal token
 */
export const loginWithToken = <ThrowOnError extends boolean = false>(options?: Options<LoginWithTokenData, ThrowOnError>) => {
    return (options?.client ?? client).post<LoginWithTokenResponses, unknown, ThrowOnError>({
        url: '/login/with-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Import sample data via CSV or XLSX file
 */
export const postDebugFileImportSampleTest = <ThrowOnError extends boolean = false>(options?: Options<PostDebugFileImportSampleTestData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostDebugFileImportSampleTestResponses, PostDebugFileImportSampleTestErrors, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/debug/file-import-sample-test',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * get survey info
 */
export const getAppByQreIdSurvey = <ThrowOnError extends boolean = false>(options: Options<GetAppByQreIdSurveyData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAppByQreIdSurveyResponses, GetAppByQreIdSurveyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/app/{qreId}/survey',
        ...options
    });
};

/**
 * update sample row
 */
export const postCommandUpdateSampleRow = <ThrowOnError extends boolean = false>(options?: Options<PostCommandUpdateSampleRowData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandUpdateSampleRowResponses, PostCommandUpdateSampleRowErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/update-sample-row',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * finalize survey
 */
export const postByQreIdFinalizeSurvey = <ThrowOnError extends boolean = false>(options: Options<PostByQreIdFinalizeSurveyData, ThrowOnError>) => {
    return (options.client ?? client).post<PostByQreIdFinalizeSurveyResponses, PostByQreIdFinalizeSurveyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/{qreId}/finalize-survey',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * delete sample by duplicity
 */
export const postCommandDeleteSampleByDuplicity = <ThrowOnError extends boolean = false>(options?: Options<PostCommandDeleteSampleByDuplicityData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandDeleteSampleByDuplicityResponses, PostCommandDeleteSampleByDuplicityErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/delete-sample-by-duplicity',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * response codes set
 */
export const postDebugByQreIdResponseCodesSet = <ThrowOnError extends boolean = false>(options: Options<PostDebugByQreIdResponseCodesSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostDebugByQreIdResponseCodesSetResponses, PostDebugByQreIdResponseCodesSetErrors, ThrowOnError>({
        url: '/debug/{qreId}/response-codes-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * get sample columns
 */
export const getSampleRowsByQreIdSampleColumns = <ThrowOnError extends boolean = false>(options: Options<GetSampleRowsByQreIdSampleColumnsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSampleRowsByQreIdSampleColumnsResponses, GetSampleRowsByQreIdSampleColumnsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample-rows/{qreId}/sample-columns',
        ...options
    });
};

/**
 * Import sample data via CSV or XLSX file
 */
export const postCommandFileImportSample = <ThrowOnError extends boolean = false>(options?: Options<PostCommandFileImportSampleData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandFileImportSampleResponses, PostCommandFileImportSampleErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/file-import-sample',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * pre call info set
 */
export const postByQreIdPreCallInfoSet = <ThrowOnError extends boolean = false>(options: Options<PostByQreIdPreCallInfoSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostByQreIdPreCallInfoSetResponses, PostByQreIdPreCallInfoSetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/{qreId}/pre-call-info-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * change response code for sample rows
 */
export const postCommandChangeSampleResponseCode = <ThrowOnError extends boolean = false>(options?: Options<PostCommandChangeSampleResponseCodeData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandChangeSampleResponseCodeResponses, PostCommandChangeSampleResponseCodeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/change-sample-response-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * cati ex alias set
 */
export const postByQreIdCatiExAliasSet = <ThrowOnError extends boolean = false>(options: Options<PostByQreIdCatiExAliasSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostByQreIdCatiExAliasSetResponses, PostByQreIdCatiExAliasSetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/{qreId}/cati-ex-alias-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * get sample row data read model with filters
 */
export const postSurveyByQreIdDefaultFilters = <ThrowOnError extends boolean = false>(options: Options<PostSurveyByQreIdDefaultFiltersData, ThrowOnError>) => {
    return (options.client ?? client).post<PostSurveyByQreIdDefaultFiltersResponses, PostSurveyByQreIdDefaultFiltersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/survey/{qreId}/default-filters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update sample data via CSV or XLSX file
 */
export const postDebugFileUpdateSampleTest = <ThrowOnError extends boolean = false>(options?: Options<PostDebugFileUpdateSampleTestData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostDebugFileUpdateSampleTestResponses, PostDebugFileUpdateSampleTestErrors, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/debug/file-update-sample-test',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * create sample row
 */
export const postCommandCreateSample = <ThrowOnError extends boolean = false>(options?: Options<PostCommandCreateSampleData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandCreateSampleResponses, PostCommandCreateSampleErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/create-sample',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export sample data as XLSX file download
 */
export const postCommandByQreIdFileExportSample = <ThrowOnError extends boolean = false>(options: Options<PostCommandByQreIdFileExportSampleData, ThrowOnError>) => {
    return (options.client ?? client).post<PostCommandByQreIdFileExportSampleResponses, PostCommandByQreIdFileExportSampleErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/{qreId}/file-export-sample',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * reset sample
 */
export const postCommandResetSample = <ThrowOnError extends boolean = false>(options?: Options<PostCommandResetSampleData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandResetSampleResponses, PostCommandResetSampleErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/reset-sample',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get operation status by operation ID (unified endpoint for upload/update/delete)
 */
export const getSampleByOperationIdOperationStatus = <ThrowOnError extends boolean = false>(options: Options<GetSampleByOperationIdOperationStatusData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSampleByOperationIdOperationStatusResponses, GetSampleByOperationIdOperationStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample/{operationId}/operation-status',
        ...options
    });
};

/**
 * Get import databases
 */
export const getAppByQreIdImportDatabases = <ThrowOnError extends boolean = false>(options: Options<GetAppByQreIdImportDatabasesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAppByQreIdImportDatabasesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/app/{qreId}/import-databases',
        ...options
    });
};

/**
 * finalize survey
 */
export const postDebugByQreIdFinalizeSurvey = <ThrowOnError extends boolean = false>(options: Options<PostDebugByQreIdFinalizeSurveyData, ThrowOnError>) => {
    return (options.client ?? client).post<PostDebugByQreIdFinalizeSurveyResponses, PostDebugByQreIdFinalizeSurveyErrors, ThrowOnError>({
        url: '/debug/{qreId}/finalize-survey',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get last sample update and sample size with optional filters
 */
export const postSampleByQreIdStatus = <ThrowOnError extends boolean = false>(options: Options<PostSampleByQreIdStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<PostSampleByQreIdStatusResponses, PostSampleByQreIdStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample/{qreId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * catiex project created
 */
export const postDebugCatiexProjectCreated = <ThrowOnError extends boolean = false>(options?: Options<PostDebugCatiexProjectCreatedData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostDebugCatiexProjectCreatedResponses, PostDebugCatiexProjectCreatedErrors, ThrowOnError>({
        url: '/debug/catiex/project-created',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get operation status by operation ID (unified endpoint for upload/update/delete)
 */
export const getDebugByOperationIdOperationStatusDebug = <ThrowOnError extends boolean = false>(options: Options<GetDebugByOperationIdOperationStatusDebugData, ThrowOnError>) => {
    return (options.client ?? client).get<GetDebugByOperationIdOperationStatusDebugResponses, GetDebugByOperationIdOperationStatusDebugErrors, ThrowOnError>({
        url: '/debug/{operationId}/operation-status-debug',
        ...options
    });
};

/**
 * quota target set
 */
export const postByQreIdQuotaTargetSet = <ThrowOnError extends boolean = false>(options: Options<PostByQreIdQuotaTargetSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostByQreIdQuotaTargetSetResponses, PostByQreIdQuotaTargetSetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/{qreId}/quota-target-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * get sample row data read model with filters
 */
export const postSampleRowsByQreIdSampleRowData = <ThrowOnError extends boolean = false>(options: Options<PostSampleRowsByQreIdSampleRowDataData, ThrowOnError>) => {
    return (options.client ?? client).post<PostSampleRowsByQreIdSampleRowDataResponses, PostSampleRowsByQreIdSampleRowDataErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample-rows/{qreId}/sample-row-data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Export sample data as XLSX file download
 */
export const postDebugByQreIdFileExportSampleTest = <ThrowOnError extends boolean = false>(options: Options<PostDebugByQreIdFileExportSampleTestData, ThrowOnError>) => {
    return (options.client ?? client).post<PostDebugByQreIdFileExportSampleTestResponses, PostDebugByQreIdFileExportSampleTestErrors, ThrowOnError>({
        url: '/debug/{qreId}/file-export-sample-test',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * quota target set
 */
export const postDebugByQreIdQuotaTargetSet = <ThrowOnError extends boolean = false>(options: Options<PostDebugByQreIdQuotaTargetSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostDebugByQreIdQuotaTargetSetResponses, PostDebugByQreIdQuotaTargetSetErrors, ThrowOnError>({
        url: '/debug/{qreId}/quota-target-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * get prometheus metrics
 */
export const getMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetMetricsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMetricsResponses, unknown, ThrowOnError>({
        url: '/metrics',
        ...options
    });
};

/**
 * get survey data read model
 */
export const getSampleRowsByQreIdSurveyData = <ThrowOnError extends boolean = false>(options: Options<GetSampleRowsByQreIdSurveyDataData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSampleRowsByQreIdSurveyDataResponses, GetSampleRowsByQreIdSurveyDataErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample-rows/{qreId}/survey-data',
        ...options
    });
};

/**
 * get CATIEx project link for survey
 */
export const getSurveyByQreIdCatiexProjectLink = <ThrowOnError extends boolean = false>(options: Options<GetSurveyByQreIdCatiexProjectLinkData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSurveyByQreIdCatiexProjectLinkResponses, GetSurveyByQreIdCatiexProjectLinkErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/survey/{qreId}/catiex-project-link',
        ...options
    });
};

/**
 * cati ex alias set
 */
export const postDebugByQreIdCatiExAliasSet = <ThrowOnError extends boolean = false>(options: Options<PostDebugByQreIdCatiExAliasSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostDebugByQreIdCatiExAliasSetResponses, PostDebugByQreIdCatiExAliasSetErrors, ThrowOnError>({
        url: '/debug/{qreId}/cati-ex-alias-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * response codes set
 */
export const postByQreIdResponseCodesSet = <ThrowOnError extends boolean = false>(options: Options<PostByQreIdResponseCodesSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostByQreIdResponseCodesSetResponses, PostByQreIdResponseCodesSetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/{qreId}/response-codes-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Public runtime configuration for the frontend
 */
export const getConfig = <ThrowOnError extends boolean = false>(options?: Options<GetConfigData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetConfigResponses, unknown, ThrowOnError>({
        url: '/config',
        ...options
    });
};

/**
 * Get running operations for qre
 */
export const getSampleByQreIdOperations = <ThrowOnError extends boolean = false>(options: Options<GetSampleByQreIdOperationsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSampleByQreIdOperationsResponses, GetSampleByQreIdOperationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample/{qreId}/operations',
        ...options
    });
};

/**
 * get CATIEx project link for survey
 */
export const getDebugSurveyByQreIdCatiexProjectLink = <ThrowOnError extends boolean = false>(options: Options<GetDebugSurveyByQreIdCatiexProjectLinkData, ThrowOnError>) => {
    return (options.client ?? client).get<GetDebugSurveyByQreIdCatiexProjectLinkResponses, GetDebugSurveyByQreIdCatiexProjectLinkErrors, ThrowOnError>({
        url: '/debug/survey/{qreId}/catiex-project-link',
        ...options
    });
};

/**
 * get quota (col, val) -> label lookup map for UI formatting
 */
export const getSurveyByQreIdQuotaFlatStructure = <ThrowOnError extends boolean = false>(options: Options<GetSurveyByQreIdQuotaFlatStructureData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSurveyByQreIdQuotaFlatStructureResponses, GetSurveyByQreIdQuotaFlatStructureErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/survey/{qreId}/quota-flat-structure',
        ...options
    });
};

/**
 * catiex project created
 */
export const postExternalEventsCatiexProjectCreated = <ThrowOnError extends boolean = false>(options?: Options<PostExternalEventsCatiexProjectCreatedData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostExternalEventsCatiexProjectCreatedResponses, PostExternalEventsCatiexProjectCreatedErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/external-events/catiex/project-created',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * get response codes
 */
export const getSurveyByQreIdResponseCodes = <ThrowOnError extends boolean = false>(options: Options<GetSurveyByQreIdResponseCodesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSurveyByQreIdResponseCodesResponses, GetSurveyByQreIdResponseCodesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/survey/{qreId}/response-codes',
        ...options
    });
};

/**
 * delete sample
 */
export const postCommandDeleteSample = <ThrowOnError extends boolean = false>(options?: Options<PostCommandDeleteSampleData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandDeleteSampleResponses, PostCommandDeleteSampleErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/delete-sample',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Update sample data via CSV or XLSX file
 */
export const postCommandFileUpdateSample = <ThrowOnError extends boolean = false>(options?: Options<PostCommandFileUpdateSampleData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCommandFileUpdateSampleResponses, PostCommandFileUpdateSampleErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/command/file-update-sample',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * pre call info set
 */
export const postDebugByQreIdPreCallInfoSet = <ThrowOnError extends boolean = false>(options: Options<PostDebugByQreIdPreCallInfoSetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostDebugByQreIdPreCallInfoSetResponses, PostDebugByQreIdPreCallInfoSetErrors, ThrowOnError>({
        url: '/debug/{qreId}/pre-call-info-set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get max (numeric) ipsos-id for survey
 */
export const getSampleByQreIdMaxIpsosId = <ThrowOnError extends boolean = false>(options: Options<GetSampleByQreIdMaxIpsosIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSampleByQreIdMaxIpsosIdResponses, GetSampleByQreIdMaxIpsosIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/sample/{qreId}/max-ipsos-id',
        ...options
    });
};
